module.exports = __webpack_public_path__ + "static/img/xy20d.6e374c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xy20d.jpg
// module id = bY/q
// module chunks = 1